import { render, staticRenderFns } from "./aiBrainList.vue?vue&type=template&id=72a5bebe"
import script from "./aiBrainList.vue?vue&type=script&lang=js"
export * from "./aiBrainList.vue?vue&type=script&lang=js"
import style0 from "./aiBrainList.vue?vue&type=style&index=0&id=72a5bebe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports